var _path, _path2, _path3, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletedSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 5.23C19.46 5.07 17.85 4.95 16.23 4.86V4.85L16.01 3.55C15.86 2.63 15.64 1.25 13.3 1.25H10.68C8.34997 1.25 8.12997 2.57 7.96997 3.54L7.75997 4.82C6.82997 4.88 5.89997 4.94 4.96997 5.03L2.92997 5.23C2.50997 5.27 2.20997 5.64 2.24997 6.05C2.28997 6.46 2.64997 6.76 3.06997 6.72L5.10997 6.52C10.35 6 15.63 6.2 20.93 6.73C20.96 6.73 20.98 6.73 21.01 6.73C21.39 6.73 21.72 6.44 21.76 6.05C21.79 5.64 21.49 5.27 21.07 5.23Z",
    fill: "#FDC22A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3991,
    d: "M19.23 8.14C18.99 7.89 18.66 7.75 18.32 7.75H5.67999C5.33999 7.75 4.99999 7.89 4.76999 8.14C4.53999 8.39 4.40999 8.73 4.42999 9.08L5.04999 19.34C5.15999 20.86 5.29999 22.76 8.78999 22.76H15.21C18.7 22.76 18.84 20.87 18.95 19.34L19.57 9.09C19.59 8.73 19.46 8.39 19.23 8.14Z",
    fill: "#FDC22A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58002 17C9.58002 16.5858 9.9158 16.25 10.33 16.25H13.66C14.0742 16.25 14.41 16.5858 14.41 17C14.41 17.4142 14.0742 17.75 13.66 17.75H10.33C9.9158 17.75 9.58002 17.4142 9.58002 17Z",
    fill: "#FDC22A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 13C8.75 12.5858 9.08579 12.25 9.5 12.25H14.5C14.9142 12.25 15.25 12.5858 15.25 13C15.25 13.4142 14.9142 13.75 14.5 13.75H9.5C9.08579 13.75 8.75 13.4142 8.75 13Z",
    fill: "#FDC22A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7251 24C20.3987 24 20.1478 23.7109 20.1938 23.3877L21.1795 16.4611C21.2171 16.1965 21.4436 16 21.7108 16C22.0372 16 22.2881 16.2891 22.2421 16.6123L21.2565 23.5389C21.2188 23.8035 20.9923 24 20.7251 24ZM17.7212 22.0156C17.3407 22.0156 17.0484 21.6784 17.1025 21.3018C17.1467 20.9941 17.4103 20.7656 17.7212 20.7656H21.879C22.2596 20.7656 22.5518 21.1028 22.4977 21.4795C22.4535 21.7872 22.1899 22.0156 21.879 22.0156H17.7212ZM18.2858 24C17.9594 24 17.7085 23.7109 17.7545 23.3877L18.7402 16.4611C18.7778 16.1965 19.0043 16 19.2715 16C19.5979 16 19.8488 16.2891 19.8028 16.6123L18.8172 23.5389C18.7795 23.8035 18.553 24 18.2858 24ZM18.1195 19.2344C17.7383 19.2344 17.4459 18.8961 17.5011 18.5189C17.546 18.2119 17.8093 17.9844 18.1195 17.9844H22.2769C22.6581 17.9844 22.9505 18.3227 22.8953 18.6999C22.8504 19.0068 22.5871 19.2344 22.2769 19.2344H18.1195Z",
    fill: "#C5CEE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedSection);
export default __webpack_public_path__ + "static/media/deleted-section.07111ec275e0726025ed5e9bea1deb07.svg";
export { ForwardRef as ReactComponent };